// TODO 0622 오픈 버전에서 버튼 주석 처리, 추 후 오픈 예정

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

// import Search from '~/shared/assets/icons/Search'
import defaultProfileImage from '~/shared/assets/images/default-profile.png'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'
import { displayMenuItems } from '~/shared/utils/routes'

function WebHeader() {
  const HeaderLogo = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/logos/illustar-logo-horizontal-kor.svg`
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)
  // const [_, setCircleTab] = useRecoilState(circleTabState)
  const [isHovering, setIsHovering] = useState(false)
  const [hasSubmenu, setHasSubmenu] = useState(false)

  const accessToken = localStorage.getItem('starlike-access-token')
  const userName = localStorage.getItem('starlike-user-name')

  return (
    <Wrapper $isHovering={isHovering}>
      <Container>
        <Logo src={HeaderLogo} onClick={() => navigate('/')} />
        <MenuBox
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          {displayMenuItems.map((menu) => {
            const hasMultipleSubItems =
              menu.subItems && menu.subItems.length > 1
            const isException = menu.path === '/sif-rainbowstage1'
            const hasSubItems = hasMultipleSubItems || isException

            return (
              <MenuItemContainer
                key={menu.path}
                onMouseEnter={() => setHasSubmenu(hasSubItems)}
                onMouseLeave={() => setHasSubmenu(false)}
              >
                <MenuItemBox onClick={() => navigate(menu.path)}>
                  <MenuItem>{menu.title}</MenuItem>
                  {hasSubItems && (
                    <SubMenuItemBox className="submenu">
                      {menu.subItems?.map((subItem) => (
                        <SubMenuItem
                          key={subItem.name}
                          onClick={(e) => {
                            e.stopPropagation()
                            navigate(subItem.path)
                          }}
                        >
                          {subItem.name}
                        </SubMenuItem>
                      ))}
                    </SubMenuItemBox>
                  )}
                </MenuItemBox>
              </MenuItemContainer>
            )
          })}
        </MenuBox>
        {!accessToken ? (
          <ButtonBox>
            <Button
              $width={92}
              $height={48}
              $fontSize={16}
              $variant="transparent"
              onClick={() => {
                setIsModalOpen({
                  ...isModalOpen,
                  contents: 'sign-in',
                  isOpen: true,
                })
              }}
            >
              로그인
            </Button>
            <Button
              $width={110}
              $height={48}
              $fontSize={16}
              $variant="black"
              onClick={() => {
                setIsModalOpen({
                  ...isModalOpen,
                  contents: 'sign-up',
                  isOpen: true,
                })
              }}
            >
              회원가입
            </Button>
            {/* <SearchWrapper
              onClick={() => navigate('/circle-participation/info')}
            /> */}
          </ButtonBox>
        ) : (
          <UserBox onClick={() => navigate('/mypage')}>
            <img
              className="user-icon"
              src={defaultProfileImage}
              alt="profile"
            />
            <div className="user-name">{userName} 님</div>
            {/* <SearchWrapper
              onClick={(e) => {
                e.stopPropagation()
                setCircleTab(1)
                navigate('/circle-participation/info')
              }}
            /> */}
          </UserBox>
        )}
      </Container>
      {isHovering && hasSubmenu && <SubItemBackground />}
    </Wrapper>
  )
}

export default WebHeader

const Wrapper = styled.header<{ $isHovering: boolean }>`
  position: absolute;
  z-index: ${theme.zIndex.header};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 100vw;
  height: ${theme.size.headerHeight}px;
  margin: 0 auto;
  padding: 36px 24px;

  background-color: ${({ $isHovering }) =>
    $isHovering ? 'rgba(255, 255, 255, 0.75)' : 'transparent'};

  @media ${theme.device.medium} {
    position: relative;
    height: auto;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  max-width: 1920px;
  padding: 12px;

  @media ${theme.device.medium} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const Logo = styled.img`
  cursor: pointer;

  width: 25%;
  min-width: 100px;
  max-width: 300px;

  object-fit: cover;

  @media ${theme.device.large} {
    width: 25%;
  }

  @media ${theme.device.medium} {
    width: 35%;
  }
`

const MenuBox = styled.div`
  z-index: ${theme.zIndex.header};

  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  gap: 50px;
  align-items: center;
  justify-content: center;

  width: 100vw;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;

  @media ${theme.device.large} {
    gap: 20px;
  }
`

const MenuItemContainer = styled.div`
  position: relative;
`

const MenuItemBox = styled.div`
  cursor: pointer;
  position: relative;
`

const MenuItem = styled.div`
  width: auto;

  &:hover {
    font-family: NanumSquareNeo-Extrabold, sans-serif;
    color: ${theme.colors.mint_3};
  }
`

const SubMenuItemBox = styled.div`
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 0;

  display: none;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;
  padding: 10px 0;

  ${MenuItemContainer}:hover & {
    display: flex;
  }
`

const SubMenuItem = styled.span`
  cursor: pointer;

  display: block;

  min-width: 150px;
  padding: 10px 0;

  white-space: nowrap;

  &:hover {
    font-family: NanumSquareNeo-Extrabold, sans-serif;
    color: ${theme.colors.mint_3};
  }
`

const SubItemBackground = styled.div`
  position: absolute;
  z-index: ${theme.zIndex.header - 1};
  top: ${theme.size.headerHeight}px;
  left: 0;

  width: 100vw;
  height: 150px;

  background-color: rgb(255 255 255 / 75%);
`

const ButtonBox = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: end;

  min-width: 260px;

  @media ${theme.device.large} {
    width: 120px;
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    min-width: auto;
  }
`

const UserBox = styled.div`
  cursor: pointer;

  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: end;

  min-width: 260px;

  .user-icon {
    width: 40px;
    height: 40px;
    background-color: aliceblue;
    border-radius: 999px;
  }

  .user-name {
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  @media ${theme.device.medium} {
    justify-content: flex-start;
    width: 100%;
    min-width: auto;
  }
`

// const SearchWrapper = styled(Search)`
//   cursor: pointer;
// `
